import { webSocket } from 'rxjs/webSocket';
import axios from 'axios';
import { Subject } from 'rxjs';
import { SDLUtil } from '@/utils';
import { WEB_CLIENT } from '@/vuex/webClient/webClientStore';
import _ from 'lodash';

/**
 * @external process
 */

export const userRole = {
  10: 'USER',
  20: 'ADMIN',
  30: 'DBA',
  40: 'Common DBA',
  50: 'Common EC2',
  60: 'Reader',
  70: 'Writer',
};

export const userRoleId = {
  10: '',
  20: '',
  30: '',
  40: 'scopdba',
  50: 'scopiam',
};

// API Url define
let webClientUrl = {
  tokenRefresh: '',
  socketUrl: '',
  init: '',
  httpUrl: '',
  authenticate: '',
  closeAllUrl: '',
  regionListUrl: '',
  projectListUrl: '',
  resourceBookmarkUrl: '',
  isRegisteredMachineUrl: '',
  sendOneTimeKeyUrl: '',
  registerMachineUrl: '',
  deregisterMachineUrl: '',
  updateEc2LocalPortUrl: '',
  deleteEc2LocalPortUrl: '',
  updateRDSCustomLocalPortUrl: '',
  deleteRDSCustomLocalPortUrl: '',
};

export const initWebClientUrl = () => {
  const WEB_CLIENT_SOCKET_URL = SDLUtil.getExternalUrl('WEB_CLIENT_SOCKET_URL');
  const WEB_CLIENT_HTTP_URL = SDLUtil.getExternalUrl('WEB_CLIENT_HTTP_URL');
  const OPEN_API_URL = SDLUtil.getExternalUrl('OPEN_API_URL');

  webClientUrl = {
    tokenRefresh: `${process.env.API_URL}/auth/users/access-token`,

    socketUrl: `${WEB_CLIENT_SOCKET_URL}`,
    init: `${WEB_CLIENT_SOCKET_URL}${SDLUtil.getExternalUrl('init')}`,

    httpUrl: `${WEB_CLIENT_HTTP_URL}`,
    authenticate: `${WEB_CLIENT_HTTP_URL}${SDLUtil.getExternalUrl('authenticate')}`,
    closeAllUrl: `${WEB_CLIENT_HTTP_URL}${SDLUtil.getExternalUrl('closeAllUrl')}`,

    regionListUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('regionListUrl')}`,
    projectListUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('projectListUrl')}`,
    resourceBookmarkUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('resourceBookmarkUrl')}`,

    isRegisteredMachineUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('isRegisteredMachineUrl')}`,
    sendOneTimeKeyUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('sendOneTimeKeyUrl')}`,
    registerMachineUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('registerMachineUrl')}`,
    deregisterMachineUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('deregisterMachineUrl')}`,

    updateEc2LocalPortUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('updateEc2LocalPortUrl')}`,
    deleteEc2LocalPortUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('deleteEc2LocalPortUrl')}`,
    updateRDSCustomLocalPortUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('updateRDSCustomLocalPortUrl')}`,
    deleteRDSCustomLocalPortUrl: `${OPEN_API_URL}${SDLUtil.getExternalUrl('deleteRDSCustomLocalPortUrl')}`,
  };
};

// WebSocket value
let ws = new Subject();

// WebSocket Callback Functions
const wsCallbacks = {};

// debug value for in this file
const debug = process.env.NODE_ENV === 'dev';

// log for in this file
const log = (...args) => {
  if (debug) console.log(...args);
};

// CORS 호출을 위한 세팅
const apiCallSettings = {
  withCredentials: true,
  headers: {
    'X-Auth-Token': localStorage.getItem('refreshToken'),
    'Content-Type': 'application/json',
    'accept-language':false,
    'last-access-time': false,
    'menu-id':false,
    'page-id':false,
    'pragma':false,
    'x-auth-refresh-token':false
  },
};

// GET/POST 호출을 위한 기본 세팅
const callCors = {
  get: async (url, moreHeaders) => {
    initWebClientUrl();

    let result = {};
    apiCallSettings.headers['X-Auth-Token'] = localStorage.getItem('refreshToken');

    try {
      if (moreHeaders !== undefined) {
        // apiCallSettings = {...apiCallSettings, headers: {...apiCallSettings.headers, ...moreHeaders}}
        Object.assign(apiCallSettings.headers, moreHeaders);
      }
      const response = await axios.get(url, apiCallSettings);
      result = response.data;
    } catch (error) {
      // log(error);
      const message = SDLUtil.getMsgProp('cop.webclient.api.call.error');
      log(message);
    }

    return result;
  },
  post: async (url, params, moreHeaders) => {
    initWebClientUrl();

    let result = {};
    apiCallSettings.headers['X-Auth-Token'] = localStorage.getItem('refreshToken');

    try {
      if (moreHeaders !== undefined) {
        // apiCallSettings = {...apiCallSettings, headers: {...apiCallSettings.headers, ...moreHeaders}}
        Object.assign(apiCallSettings.headers, moreHeaders);
      }
      const response = await axios.post(url, JSON.stringify(params), apiCallSettings);
      result = response.data;
    } catch (error) {
      // log(error);
      const message = SDLUtil.getMsgProp('cop.webclient.api.call.error');
      log(message);
    }

    return result;
  },
};

// 최신 Machine Token 으로 POST
const postWithMachineKey = async (url, params = {}) => {
  initWebClientUrl();
  const authResult = await authenticate();
  const machineInfo = authResult.data;
  const machineKeyHeader = {
    Authtoken: machineInfo.mchn_token,
  };

  return callCors.post(url, params, machineKeyHeader);
};


// region OpenAPI Call

// /**
//  * OpenAPI 사용자가 접근 가능한 프로젝트들의 리스트
//  * @returns {Promise<{}>}
//  */
// export const getProjectListFromAPI = () => callCors.post(webClientUrl.projectListUrl, { user_seq_no });

/**
 * OpenAPI CSP 회사들의 지역 리스트
 * @returns {Promise<{}>}
 */
export const getRegionList = (machineKey) => {
  initWebClientUrl();
  const moreHeaders = {
    Authtoken: machineKey,
  };
  return callCors.get(webClientUrl.regionListUrl, moreHeaders);
};

/**
 * 머신 등록 여부
 * @returns {Promise<{}>}
 */
export const isRegisteredMachine = () => {
  initWebClientUrl();
  return callCors.get(webClientUrl.isRegisteredMachineUrl);
}

/**
 * One time Key 메일 발송
 * @returns {Promise<{}>}
 */
export const sendOneTimeKey = () => {
  initWebClientUrl();
  return callCors.post(webClientUrl.sendOneTimeKeyUrl);
}

/**
 * Machine 등록
 * @returns {Promise<{}>}
 */
export const registerMachine = (oneTimeKey, machineIP, machineMAC) => {
  initWebClientUrl();
  const moreHeaders = {
    Authtoken: oneTimeKey,
  };
  const param = {
    mchn_ip: machineIP,
    mchn_mac: machineMAC,
  };
  return callCors.post(webClientUrl.registerMachineUrl, param, moreHeaders);
};
export const registerMachineV2 = (oneTimeKey, machineIP, machineMAC, biosSn, diskDriveSn) => {
  initWebClientUrl();
  const moreHeaders = {
    Authtoken: oneTimeKey,
  };
  const param = {
    mchn_ip: machineIP,
    mchn_mac: machineMAC,
    bios_sn: biosSn,
    disk_drive_sn: diskDriveSn,
  };
  return callCors.post(webClientUrl.registerMachineUrl, param, moreHeaders);
};

/**
 * Machine 해제
 * @returns {Promise<{}>}
 */
export const deRegisterMachine = (oneTimeKey) => {
  initWebClientUrl();
  const moreHeaders = {
    Authtoken: oneTimeKey,
  };
  return callCors.post(webClientUrl.deregisterMachineUrl, null, moreHeaders);
};

export const updateUserResourceBookmark = (data) => {
  initWebClientUrl();
  return postWithMachineKey(webClientUrl.resourceBookmarkUrl, data);
}

/**
 * local port 변경
 * @returns {Promise<{}>}
 */
export const saveLocalPort = (data) => {
  initWebClientUrl();
  return postWithMachineKey(webClientUrl.updateEc2LocalPortUrl, data);
}

/**
 * local port 삭제
 * @returns {Promise<{}>}
 */
export const deleteLocalPort = (data) => {
  initWebClientUrl();
  return postWithMachineKey(webClientUrl.deleteEc2LocalPortUrl, data);
}

/**
 * RDS local port 변경
 * @returns {Promise<{}>}
 */
export const saveLocalPortRDS = (data) => {
  initWebClientUrl();
  return postWithMachineKey(webClientUrl.updateRDSCustomLocalPortUrl, data);
}

/**
 * RDS local port 삭제
 * @returns {Promise<{}>}
 */
export const deleteLocalPortRDS = (data) => {
  initWebClientUrl();
  return postWithMachineKey(webClientUrl.deleteRDSCustomLocalPortUrl, data);
}

// endregion OpenAPI Call


// region WebClientAgent Call


/**
 * WebClientAgent 인증
 * WebClientAgent 에서 OpenAPI 를 호출 할 때 사용할 token 을 전달
 * @returns {Promise<*>}
 */
export const authenticate = () => {
  initWebClientUrl();
  return callCors.post(webClientUrl.authenticate, {
    token: localStorage.getItem('refreshToken'),
    refresh_token: localStorage.getItem('refreshToken'),
  });
}

const webSocketNext = async params => {
  initWebClientUrl();

  ws.next(params);
};

/**
 * WebSocket Subscribes 설정
 */
const setSubscribes = () => {
  initWebClientUrl();

  ws.subscribe({
    next: msg => {
      if (msg.error_code === 14001) {
        getWebClientSocket(vueThis2).then(r => r);
      }

      if (msg.error_code === 10121) {
        vueThis2.openErrorToast(msg.message);
      }

      const command = msg.web_socket_cmd || msg.data.message;

      switch (command) {
        case WEB_CLIENT.COMMAND.CONNECT:
          break;
        case WEB_CLIENT.COMMAND.SERVER_DISCONNECT:
          break;
        case WEB_CLIENT.COMMAND.CONNECT_WINSCP:
          break;
        case WEB_CLIENT.COMMAND.GET_RDS_TOKEN:
          break;
        case WEB_CLIENT.COMMAND.GET_RESOURCE_LIST:
          break;
        case WEB_CLIENT.COMMAND.GET_SERVICE_LIST:
          break;
        case WEB_CLIENT.COMMAND.REFRESH:
          break;
        case WEB_CLIENT.COMMAND.INIT:
          break;
        case WEB_CLIENT.COMMAND.GET_EC2_TOKEN:
          break;
        case WEB_CLIENT.COMMAND.ACCESS_CHANGED:
          break;
        default:
          break;
      }

      // 콜백 함수 호출
      if (command in wsCallbacks) {
        if (typeof wsCallbacks[command] === 'function') {
          wsCallbacks[command](msg);
        } else if (typeof wsCallbacks[command] === 'object') {
          let resourceKey = '';
          switch (msg.data.rsrc_type_cd) {
            case 'EC2':
              resourceKey = `key${msg.data.seq_no}${msg.data.rmt_port_no}`;
              break;
            case 'RDS':
              resourceKey = `key${msg.data.seq_no}${msg.data.db_port_no}`;
              break;
            default:
              resourceKey = '';
              break;
          }

          const callbacks = {};
          if (resourceKey) {
            callbacks.success = wsCallbacks[command][resourceKey].success;
            callbacks.fail = wsCallbacks[command][resourceKey].fail;
          } else {
            callbacks.success = wsCallbacks[command].success;
            callbacks.fail = wsCallbacks[command].fail;
          }

          if (msg.status === 0) {
            callbacks.success(msg);
          } else {
            callbacks.fail(msg);
          }
        }
      }
    },
    error: err => {
      log(err);
      const message = SDLUtil.getMsgProp('cop.webclient.socket.call.error');
      log(message);
    },
    complete: () => {
      log('WebClientAgent WebSocket Complete.');
      const message = SDLUtil.getMsgProp('cop.webclient.socket.complete');
      log(message);
    },
  });
};

let vueThis2 = {};
/**
 * WebClientAgent 와 Socket 연결
 * @returns {Promise<{ws: Subject<T>, machineInfo: *}>}
 */
export const getWebClientSocket = async (vueThis) => {
  initWebClientUrl();

  vueThis2 = vueThis;
  const authResult = await authenticate();
  const machineInfo = authResult.data;

  if (ws instanceof Subject || ws.closed) {
    ws = webSocket({
      url: webClientUrl.init,
      closeObserver: {
        next: () => {
          log('close');
          ws = new Subject();
          vueThis.$store.commit('setWebClientSocketConnectionState', false);
          vueThis.openErrorToast('Disconnected with WebClientAgent.\nTry Client Connection again');
        },
      },
    });
    setSubscribes();
    vueThis.$store.commit('setWebClientSocketConnectionState', true);
  } else {
    log('exist');
  }

  if (authResult.error_code === 11002) {
    SDLUtil.showLoadingBar(false);
    vueThis.openErrorToast(SDLUtil.getMsgProp('Invalid User'));
  }

  return { ws, machineInfo };
};

/**
 * WebSocket 호출 시 필요한 기본 파라메터 설정
 * @param command 호출 할 명령
 * @param params 기존 파라메터
 * @returns {{message: string, auth_token: string}}
 */
export const getCommandParams = (command, params = {}) => ({
  ...params,
  message: command,
  auth_token: localStorage.getItem('refreshToken'),
  refresh_token: localStorage.getItem('refreshToken'),
});

/**
 * WebSocket 호출
 * @param params
 * @param callback 콜백 함수
 * @param fail 실패시 콜백 함수
 */
export const runCommand = (params, callback, fail) => {
  initWebClientUrl();

  let resourceKey = '';
  if (params.rsrc_type_cd) {
    switch (params.rsrc_type_cd) {
      case 'EC2':
        resourceKey = `key${params.seq_no}${params.rmt_port_no}`;
        break;
      case 'RDS':
        resourceKey = `key${params.seq_no}${params.db_port_no}`;
        break;
      default:
        resourceKey = '';
        break;
    }
  }

  if (typeof wsCallbacks[params.message] === 'undefined') {
    wsCallbacks[params.message] = {};
  }

  if (resourceKey) {
    wsCallbacks[params.message][resourceKey] = {};
    wsCallbacks[params.message][resourceKey].success = callback;
    wsCallbacks[params.message][resourceKey].fail = fail;
  } else {
    wsCallbacks[params.message].success = callback;
    wsCallbacks[params.message].fail = fail;
  }

  webSocketNext(params).then(r => r);
};

/**
 * 프로젝트 리스트 호출
 */
export const getProjectList = (success, fail) => {
  initWebClientUrl();

  const params = getCommandParams(WEB_CLIENT.COMMAND.GET_SERVICE_LIST);

  wsCallbacks[WEB_CLIENT.COMMAND.GET_SERVICE_LIST] = {};
  wsCallbacks[WEB_CLIENT.COMMAND.GET_SERVICE_LIST].success = success;
  wsCallbacks[WEB_CLIENT.COMMAND.GET_SERVICE_LIST].fail = fail;
  webSocketNext(params).then(r => r);
};

/**
 * 자원 리스트 호출
 * @param projectUid 프로젝트 고유값
 * @param projectName 프로젝트 태그명
 * @param env 환경 태그명
 * @param cspCode CSP 코드
 * @param resourceTypeCode 자원 타입 코드
 * @param callback 콜백 함수
 */
export const getResourceList = ({ projectUid, projectName, env, cspCode, resourceTypeCode }, callback) => {
  initWebClientUrl();
  const params = getCommandParams(WEB_CLIENT.COMMAND.GET_RESOURCE_LIST, {
    project_uid: projectUid,
    project_nm: projectName,
    env,
    csp_cd: cspCode,
    rsrc_type_cd: resourceTypeCode,
  });
  wsCallbacks[WEB_CLIENT.COMMAND.GET_RESOURCE_LIST] = callback;
  webSocketNext(params).then(r => r);
};

// endregion WebClientAgent Call

// region Utilities
export const copyToClipboard = async (message) => {
  initWebClientUrl();
  await navigator.clipboard.writeText(message);
};

export const getResourceUserID = (userId, role) => {
  initWebClientUrl();
  return userRoleId[role] || userId;
}
// endregion Utilities

export default {};



// WEBPACK FOOTER //
// ./src/service/webClientService.js